module.exports = __webpack_public_path__ + "img/fashion_15.64aad9ef.jpg";